class RotatingFeatureBlocks {
  constructor(parent) {
    this.parent = parent;
    this.blocks = Array.from(parent.querySelectorAll(".feature-block"));
    this.timerId = null;

    this.currentIndex = this.getInitialActiveIndex();
    this.speed = this.getRotationSpeed();

    if (this.blocks.length <= 1) return;

    this.setActive(this.currentIndex);
    this.start();
  }

  getRotationSpeed() {
    const raw = this.parent.getAttribute("data-rotation-speed");
    const speed = Number(raw);
    return Number.isFinite(speed) && speed >= 200 ? speed : 1000;
  }

  getInitialActiveIndex() {
    const idx = this.blocks.findIndex((b) => b.classList.contains("active"));
    return idx >= 0 ? idx : 0;
  }

  setActive(index) {
    this.blocks.forEach((block, i) => {
      block.classList.toggle("active", i === index);
    });
  }

  next() {
    this.currentIndex = (this.currentIndex + 1) % this.blocks.length;
    this.setActive(this.currentIndex);
  }

  start() {
    this.stop();
    this.timerId = setInterval(() => this.next(), this.speed);
  }

  stop() {
    if (this.timerId) {
      clearInterval(this.timerId);
      this.timerId = null;
    }
  }

  destroy() {
    this.stop();
  }
}

class RotatingFeatureBlocksManager {
  constructor() {
    this.instances = new Map();
    this.selector = "[data-section-tab]";
  }

  initAll(root = document) {
    root.querySelectorAll(this.selector).forEach((sectionEl) => this.initOne(sectionEl));
  }

  initOne(sectionEl) {
    const sectionId = sectionEl.getAttribute("data-section-id") || sectionEl;
    if (this.instances.has(sectionId)) {
      this.instances.get(sectionId).destroy();
      this.instances.delete(sectionId);
    }

    const instance = new RotatingFeatureBlocks(sectionEl);
    this.instances.set(sectionId, instance);
  }

  destroyOne(sectionEl) {
    const sectionId = sectionEl.getAttribute("data-section-id") || sectionEl;
    const inst = this.instances.get(sectionId);
    if (inst) inst.destroy();
    this.instances.delete(sectionId);
  }
}

(function () {
  const manager = new RotatingFeatureBlocksManager();

  const boot = () => manager.initAll();

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", (event) => {
    manager.initAll(event.target);
  });

  document.addEventListener("shopify:section:unload", (event) => {
    const sectionEl = event.target.querySelector?.("[data-section-tab]") || event.target;
    if (sectionEl?.matches?.("[data-section-tab]")) manager.destroyOne(sectionEl);
  });
})();